import { render, staticRenderFns } from "./captain_form_create.vue?vue&type=template&id=47ba95f5&scoped=true&"
import script from "./captain_form_create.vue?vue&type=script&lang=js&"
export * from "./captain_form_create.vue?vue&type=script&lang=js&"
import style0 from "./captain_form_create.vue?vue&type=style&index=0&id=47ba95f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba95f5",
  null
  
)

export default component.exports